export default "__VITE_ASSET__a87a45f8__"